/* eslint-disable jsx-a11y/label-has-associated-control */
import * as React from "react";
import { useField } from "formik";
import classNames from "classnames";

// Components
import Label from "../Label/Label";
import ErrorText from "../ErrorText/ErrorText";
import FeedbackText from "../FeedbackText/FeedbackText";

// Context
import { useConditionDispatch } from "../../context/Condition.context";

// Types
import Answer from "../../types/Answer.interface";
import Feedback from "../../types/Feedback.interface";

// Misc.
import useFeedback from "../../lib/useFeedback.lib";

interface InputTextField {
  id: string;
  label: string;
  answers?: Answer[];
  feedback: Feedback[];
}

const InputTextField: React.FC<InputTextField> = (props: InputTextField) => {
  const { id, label, answers, feedback } = props;
  const [field, meta, helper] = useField(id);
  const [feedbackData] = useFeedback(feedback, field);
  const condDispatch = useConditionDispatch();

  const styleClasses = classNames(
    "w-full py-2 px-3 text-dw-grey-13 rounded-none mt-3",
    {
      "border-b-2 border-dw-red": meta.error && meta.touched,
    }
  );

  return (
    <fieldset>
      {answers && (
        <>
          <Label inputId={answers[0]._id}>{label}</Label>
          <input
            type="text"
            id={answers[0]._id}
            autoComplete="off"
            className={styleClasses}
            {...field}
            value={field.value.value}
            maxLength={150}
            onChange={
              (e) => {
                helper.setValue({ id: answers[0]._id, value: e.target.value });
                condDispatch({
                  type: "add",
                  payload: {
                    [id]: { id: answers[0]._id, value: e.target.value },
                  },
                });
              }
              // eslint-disable-next-line react/jsx-curly-newline
            }
          />
          {meta.error && meta.touched && (
            <ErrorText text={(meta.error as any).value} />
          )}
          {feedbackData && meta.touched && field.value.value && (
            <FeedbackText text={feedbackData} />
          )}
        </>
      )}
    </fieldset>
  );
};

export default InputTextField;
